import { vservice } from '@niknevis/vue-modules'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { BootLayoutResource } from '@/modules/common/layout/models/layout-resource.model'
import { LayoutRoute } from '@/modules/common/layout/routes/layout.route'

@vservice()
export class LayoutService {
  constructor(
    private readonly routes: LayoutRoute
  ) {
  }

  bootData(): Promise<BootLayoutResource> {
    return HTTP.get(
      this.routes.boot
    ).then(result => result.json())
  }

}